"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledRemoveModal = void 0;
var React = require("react");
var react_1 = require("react");
var ScheduleDeletionWrapper_1 = require("./components/ScheduleDeletionWrapper");
var ScheduledRemoveModal = function (props) {
    var _a, _b, _c;
    var _d = (0, react_1.useState)((_a = props.ttl) === null || _a === void 0 ? void 0 : _a.retentionTimeUnits), retentionTimeUnits = _d[0], setRetentionTimeUnits = _d[1];
    var _e = (0, react_1.useState)((_c = (_b = props.ttl) === null || _b === void 0 ? void 0 : _b.retentionTime) !== null && _c !== void 0 ? _c : null), retentionTime = _e[0], setRetentionTime = _e[1];
    var _f = (0, react_1.useState)(false), isInputChanged = _f[0], setIsInputChanged = _f[1];
    var prevTTL = React.useRef(null);
    var isInputValid = function () {
        var isRetentionTimeInteger = Number.isInteger(retentionTime);
        var isRetentionTimeUnitsDefined = typeof retentionTimeUnits === 'string' && retentionTimeUnits.length > 0;
        if (!isRetentionTimeInteger && !isRetentionTimeUnitsDefined)
            return true;
        if (!isRetentionTimeInteger || !isRetentionTimeUnitsDefined)
            return false;
        var retentionTimeValue = Number(retentionTime);
        var isLessThanOne = retentionTimeValue < 1;
        var isLessThanFourteenDays = retentionTimeUnits === 'days' && retentionTimeValue < 14;
        var isLessThanTwoWeeks = retentionTimeUnits === 'weeks' && retentionTimeValue < 2;
        return !(isLessThanOne || isLessThanFourteenDays || isLessThanTwoWeeks);
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (props.ttl !== prevTTL.current) {
            setRetentionTime((_b = (_a = props.ttl) === null || _a === void 0 ? void 0 : _a.retentionTime) !== null && _b !== void 0 ? _b : null);
            setRetentionTimeUnits((_c = props.ttl) === null || _c === void 0 ? void 0 : _c.retentionTimeUnits);
            prevTTL.current = props.ttl;
        }
    }, [props.ttl]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        var isTimeChanged = retentionTime !== ((_b = (_a = props.ttl) === null || _a === void 0 ? void 0 : _a.retentionTime) !== null && _b !== void 0 ? _b : null);
        var isUnitsChanged = retentionTimeUnits !== ((_c = props.ttl) === null || _c === void 0 ? void 0 : _c.retentionTimeUnits);
        setIsInputChanged(isTimeChanged || isUnitsChanged);
    }, [retentionTime, retentionTimeUnits, props.ttl]);
    return (React.createElement(ScheduleDeletionWrapper_1.ScheduledDeletionWrapper, __assign({}, props, { retentionTime: retentionTime, setRetentionTime: setRetentionTime, retentionTimeUnits: retentionTimeUnits, setRetentionTimeUnits: setRetentionTimeUnits, isInputChanged: isInputChanged, isInputValid: isInputValid() })));
};
exports.ScheduledRemoveModal = ScheduledRemoveModal;
